const routes = [
  {
    name: "Blog",
    children: [
      {
        name: "Add Banner",
        path: "/dashboard/banner",
        permission: "manage_banners",
      },
      {
        name: "Blog Listing",
        path: "/dashboard/blog",
        permission: "manage_blogs",
      },
    ],
  },
  {
    name: "Press",
    path: "/dashboard/newslink",
    permission: "manage_press",
  },
  {
    name: "Sitemap",
    path: "/dashboard/sitemap",
    permission: "manage_site_mappings",
  },
  {
    name: "Contact",
    path: "/dashboard/contact-us",
    permission: "manage_contacts", // Admin only feature
  },
  {
    name: "Jobs",
    path: "/dashboard/jobs",
    permission: "manage_jobs", // Admin only feature
  },
  {
    name: "Store Locations",
    path: "/dashboard/store-location",
    permission: "manage_locators", // Admin only feature
  },
  {
    name: "FAQs",
    path: "/dashboard/faq/category-list",
    permission: "manage_categories", // Admin only feature
  },
  {
    name: "MetatagsandSEO",
    path: "/dashboard/category/category-list-application",
    permission: "manage_content_meta_tags" || "view_content_meta_tags",
  },
  {
    name: "Dynamic Booking Location Routes",
    path: "/dashboard/bookinglocation/dynamic-location-routes",
    permission: "manage_routes",
  },
  {
    name: "Product Page Banner Video & Details",
    path: "/dashboard/PageCategoryDetails/page-category-details",
    permission: "manage_dynamic_pages",
  },

  {
    name: "Announcement Ticker",
    path: "/dashboard/announcement-ticker",
    permission: ["ADMIN"],
  },

  {
    name: "Offers Page Data",
    path: "/dashboard/Offers-page-data",
    permission: ["ADMIN"],
  },

  {
    name: "Campaign Review",
    path: "/dashboard/testimonial-list",
    permission: "manage_testimonials",
  },
  {
    name: "Interim Storage",
    path: "/dashboard/interim-storage",
    permission: "manage_interim_storage", // Admin only feature
  },
  {
    name: "Corporate Enquiry",
    path: "/dashboard/corporate-enquiry",
    permission: "manage_enquiry",
  },
  {
    name: "Candidate Listing",
    path: "/hr-portal/candidate-listing",
    permission: "manage_candidates", // HR feature
  },
  {
    name: "Job Listing",
    path: "/hr-portal/job-listing",
    permission: "manage_job_listings", // HR feature
  },
  {
    name: "Dussehra Campaign",
    path: "/dashboard/event-lead",
    permission: "manage_campaigns", // Admin only feature
  },
  {
    name: "Dealership Leads",
    path: "/dashboard/dealership-lead",
    permission: "manage_dealership_leads", // Admin only feature
  },
  {
    name: "Buy Now",
    path: "/dashboard/buy-now",
    permission: "manage_dealership_leads", // Admin only feature
  },
  {
    name: "Vehicle Pricing",
    path: "/dashboard/vehicle-pricing",
    permission: "manage_dealership_leads",
  },
  {
    name: "Evo Bookings",
    path: "/dashboard/evo-bookings",
    permission: "manage_dealership_leads",
  },
  {
    name: "Vas Purchase",
    path: "/dashboard/vas-purchase",
    permission: "manage_dealership_leads",
  },
  {
    name: "Pre Bookings",
    path: "/dashboard/pre-bookings",
    permission: "manage_dealership_leads",
  },
  {
    name: "URL Redirects",
    path: "/dashboard/redirects",
    permission: "manage_redirects",
  },

];

export default routes;
